import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent, cloneElement, isValidElement } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Spinner from '../Spinner';
import { withStyles } from '../theme';
import { isolateMixin, ifMobile, focusSourceMixin } from '../utils/mixins';
import { subscribeFocusEvents } from '../utils/focus-source';
subscribeFocusEvents();

var styles = function styles(theme) {
  return _extends({
    button: {
      extend: isolateMixin,
      cursor: 'pointer',
      boxSizing: 'border-box',
      borderRadius: theme.iconButton.borderRadius,
      outline: 'none',
      position: 'relative',
      display: 'inline-block',
      border: 'none !important',
      userSelect: 'none',
      verticalAlign: 'middle',
      '&, & *': {
        transition: 'background-color .2s, border .2s, box-shadow .2s'
      },
      '&:before, &:after': {
        content: '""',
        display: 'block',
        position: 'absolute',
        pointerEvents: 'none',
        borderRadius: theme.iconButton.borderRadius,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        border: '1px solid transparent',
        transition: 'all .2s'
      },
      '&[disabled]': {
        pointerEvents: 'none'
      },
      '&::-moz-focus-inner': {
        border: 'none !important',
        outline: 'none !important'
      }
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1,
      opacity: 0,
      width: '100%',
      cursor: 'pointer'
    },
    icon: {
      flex: 'none',
      fontSize: theme.iconButton.iconPercentSize + '%',
      width: '1em',
      height: '1em',
      margin: 'auto',
      transition: 'fill .2s',
      '$size-medium &, $size-small &': _extends({
        fontSize: theme.iconButton.sizes.icon
      }, ifMobile({
        fontSize: theme.iconButton.mobile.sizes.icon
      }))
    },
    iconWithStandardColor: {},
    isLoading: {
      pointerEvents: 'none',
      opacity: 0
    },
    loader: _extends({
      fontSize: 3
    }, ifMobile({
      fontSize: 4
    })),
    content: {
      display: 'flex',
      width: '1em',
      height: '1em'
    },
    'size-medium': _extends({
      fontSize: theme.iconButton.sizes.medium
    }, ifMobile({
      fontSize: theme.iconButton.mobile.sizes.medium
    })),
    'size-small': _extends({
      fontSize: theme.iconButton.sizes.small
    }, ifMobile({
      fontSize: theme.iconButton.mobile.sizes.small
    }))
  }, ['primary', 'secondary', 'outline', 'flat', 'danger'].reduce(function (result, type) {
    var conf = theme.button.types[type];
    var offset = conf.outlineOffset || 0;

    var setThemeForSelector = function setThemeForSelector(colors, outlineOffset) {
      return {
        background: colors.background,
        '&:before': _extends({}, colors.border && {
          borderColor: colors.border
        }),
        '&:after': _extends({}, colors.outline && {
          left: -outlineOffset,
          right: -outlineOffset,
          top: -outlineOffset,
          bottom: -outlineOffset,
          borderColor: colors.outline
        }),
        '& $iconWithStandardColor': {
          color: colors.icon
        }
      };
    };

    return _extends({}, result, _defineProperty({}, "type-".concat(type), _extends({}, setThemeForSelector(conf.colors.default, offset), {
      '&:hover': setThemeForSelector(conf.colors.hover, offset),
      '&:active': setThemeForSelector(conf.colors.active, offset),
      '&[disabled]': setThemeForSelector(conf.colors.disabled, offset)
    }, focusSourceMixin('other', '&:focus', setThemeForSelector(conf.colors.focus, offset)), {
      '& $loader': {
        color: conf.colors.default.loader
      }
    })));
  }, {}));
};

var _ref = /*#__PURE__*/React.createElement("div", null);

var IconButton = /*#__PURE__*/function (_PureComponent) {
  _inherits(IconButton, _PureComponent);

  var _super = _createSuper(IconButton);

  function IconButton() {
    _classCallCheck(this, IconButton);

    return _super.apply(this, arguments);
  }

  _createClass(IconButton, [{
    key: "renderIcon",
    value: function renderIcon(icon) {
      if (!icon) return null;
      var _this$props = this.props,
          type = _this$props.type,
          disabled = _this$props.disabled,
          classes = _this$props.classes;
      var initialProps = icon.props || {};
      var isStandardColor = type === 'primary' || type === 'danger' || disabled || !initialProps.hasOwnProperty('color');
      var iconProps = {
        size: null
      };
      if (isStandardColor) iconProps.color = 'currentColor';
      var className = classnames(initialProps.className, classes.icon, isStandardColor && classes.iconWithStandardColor);

      var resultProps = _extends({}, initialProps, {}, iconProps, {
        className: className
      });

      return cloneElement(icon, resultProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          type = _this$props2.type,
          container = _this$props2.container,
          buttonType = _this$props2.buttonType,
          disabled = _this$props2.disabled,
          className = _this$props2.className,
          overlay = _this$props2.overlay,
          width = _this$props2.width,
          loading = _this$props2.loading,
          size = _this$props2.size,
          _this$props2$style = _this$props2.style,
          style = _this$props2$style === void 0 ? {} : _this$props2$style,
          classes = _this$props2.classes,
          theme = _this$props2.theme,
          other = _objectWithoutProperties(_this$props2, ["children", "type", "container", "buttonType", "disabled", "className", "overlay", "width", "loading", "size", "style", "classes", "theme"]);

      var iconEl = this.renderIcon(children);
      var isStandardSize = typeof this.props.size !== 'number';

      var resultStyle = _extends({
        width: width,
        fontSize: isStandardSize ? null : size
      }, style);

      var resultClassName = classnames(className, classes.button, classes["type-".concat(type)], isStandardSize && classes["size-".concat(size)]);
      var resultChildren = React.createElement("span", {
        className: classnames(classes.content, loading && classes.isLoading)
      }, iconEl, overlay && cloneElement(overlay, {
        className: classes.overlay
      }));

      var resultProps = _extends({}, other, {
        style: resultStyle,
        className: resultClassName,
        disabled: disabled ? 'disabled' : null
      });

      var resultContainer = isValidElement(container) ? container : overlay ? _ref : React.createElement("button", {
        type: buttonType
      });
      return cloneElement(resultContainer, resultProps, resultChildren, loading && React.createElement(Spinner, {
        className: classes.loader,
        color: null
      }));
    }
  }]);

  return IconButton;
}(PureComponent);

IconButton.defaultProps = {
  type: 'primary',
  size: 'medium',
  buttonType: 'button'
};
IconButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Тип стиля кнопки
   */
  type: PropTypes.oneOf(['primary', 'secondary', 'outline', 'flat', 'danger']),

  /**
   * Css-класс
   */
  className: PropTypes.string,

  /**
   * Inline-стили
   */
  style: PropTypes.object,

  /**
   * Контент для кнопки
   */
  children: PropTypes.node,

  /**
   * Размер кнопки - small/medium или размер в пикселях
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['small', 'medium'])]),

  /**
   * Обработчик клика
   */
  onClick: PropTypes.func,

  /**
   * Элемент, который содержит контент, например `<Link />` в случае с `react-router`, или `<a />` если необходима ссылка
   */
  container: PropTypes.element,

  /**
   * Элемент, который прозрачно накладывается на кнопку (Например `<input type="file" />`)
   */
  overlay: PropTypes.element,

  /**
   * Отключаем кнопку/ссылку
   */
  disabled: PropTypes.bool,

  /**
   * Тип кнопки
   */
  buttonType: PropTypes.string,

  /**
   * Показывать индикатор загрузки
   */
  loading: PropTypes.bool,

  /**
   * Ширина кнопки
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default withStyles(styles, {
  name: 'IconButton'
})(IconButton);